import { CommonService } from '@app/shared/services/common.service';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CreateScheduleService } from '@app/shared/services/create-schedule.service';
import { DataService } from '@app/shared/services/data.service';
import {
  ModalController,
  NavController,
  IonSearchbar
} from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { RecivedParams, Station } from '../model/create-schedule';
import { StationDetails } from '../model/schedule-model';
import { ScheduleWeatherNotamsComponent } from '../schedule-weather-notams/schedule-weather-notams.component';
import { googleMapProperty } from '@app/trips/trips-tab/constants/constant-message';
import { defaultSESpeed } from '@app/shared/constants/constant';
import { CreateTrip } from '@app/charter/model/schedule-creation';
import { CharterTripService } from '@app/charter/data-access/charter-trip-service';
import { SharedComponentModule } from '@app/shared/components/shared-component.module';
import { FlightPlanModule } from '@app/flight-planning/flight-plan.module';
@Component({
    selector: 'app-schedule-airport',
    templateUrl: './schedule-airport.component.html',
    styleUrls: ['./schedule-airport.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, IonicModule, SharedComponentModule, FlightPlanModule]
})
export class ScheduleAirportComponent implements OnInit {
  @ViewChild('autofocus', { static: false }) public searchbar!: IonSearchbar;
  @Input() public SendData?: RecivedParams;
  @Input('pageType') public pageTypeInput?: string;
  @Input() public SelectedAltTrip?: string;
  @Input('Regd') public RegdInput?: string;
  @Input() public Latitude?: string;
  @Input() public Longitude?: string;
  @Input() public SetTrip?: CreateTrip;
  @Input() public minimumRunwayLength?: string;
  @Input() public stationToFilter?: string;
  @Input() public speed?: number;
  public enableConfirm: boolean = false;
  public autocomplete!: string;
  public stationList = new Array<Station>();
  public autocompleteItems = new Array<Station>();
  public dataLoaded: boolean = false;
  public receivedData!: RecivedParams;
  public SelectStation:any[] = [];
  public fullStation: StationDetails  | undefined;;
  public setTrip = new CreateTrip();
  public pageType!: string;
  public selectedAltTrip: any;
  public sortedStationList: any[] = [];
  public Regd: any;
  public wxWeather: any;
  public toStationLatLong!:string;
  public isStationSelected:boolean=false;
  public flightPlanUrl:any;
  public fromStationLatLong:any;
  public textToSearch: string = '';
  public isFirstStationSelected:boolean=false;
  public firstStationData:any;
  public filterListOfSTations:any;
  public distance!:string;
  public usertype!: number;
  @ViewChild('paragraph', { static: true }) public paragraph!: ElementRef<HTMLParagraphElement>;
  constructor(
    public navCtrl: NavController,
    private dataservice: DataService,
    private modalController: ModalController,
    public scheduleService: CreateScheduleService,
    public commonService: CommonService,
    private charterTripService:CharterTripService,
  ) { }
  public ngOnInit() {
    setTimeout(() => this.focusSearchbar(), 600);
    this.Regd = this.RegdInput ?? this.Regd;
    this.receivedData = this.getParam<RecivedParams>('SendData', this.SendData);
    this.pageType = this.getParam<string>('pageType', this.pageTypeInput);
    this.selectedAltTrip = this.getParam<string>('SelectedAltTrip', this.SelectedAltTrip);
    this.usertype = this.commonService.roleId;
    const lat  =  this.getParam<string>('Latitude', this.Latitude);
    const setTrip  =  this.getParam<CreateTrip>('SetTrip', this.SetTrip);
    const long  =  this.getParam<string>('Longitude', this.Longitude);
    if (setTrip) {
      this.setTrip = setTrip;
    }
    if(setTrip && setTrip.fromStation && this.commonService.roleId=='7')
    {
      this.setTrip.fromStation=setTrip.fromStation;
      this.setTrip.starttimeZone=setTrip.starttimeZone;
    }
    this.fromStationLatLong=lat+ ',' + long; // For Charter FromStationLatLong
    if (this.pageType == 'ScheduleCreation') {
      if (
        this.receivedData.stationType == 'from' ||
        this.receivedData.stationType == 'to' ||
        this.receivedData.stationType == 'Deaprtalternate'
      ) {
        if (this.receivedData?.departure && this.receivedData?.departure != '') {
          this.fullStation = new StationDetails(
            this.receivedData.departure,
            this.receivedData.timeZoneVal ?? ''
          );
          this.SelectStation.push(this.receivedData.departure.split(',')[0]);
        }
        this.getStations();
      } else if (
        this.receivedData.stationType == 'Tripalternate' ||
        this.receivedData.stationType == 'Tripalternate2' ||
        this.receivedData.stationType == 'fromStation'
      ) {
        if (this.selectedAltTrip && this.selectedAltTrip != '') {
          this.fullStation = new StationDetails(
            this.selectedAltTrip,
            this.receivedData.timeZoneVal ?? ''
          );
          this.SelectStation.push(this.selectedAltTrip.split(',')[0]);
        }
        this.getStations();
      }
    } else {
      if (this.selectedAltTrip && this.selectedAltTrip != '') {
        this.fullStation = new StationDetails(
          this.selectedAltTrip,
          this.receivedData.timeZoneVal ?? ''
        );
        this.SelectStation.push(this.selectedAltTrip.split(',')[0]);
      }
      this.getStations();
    }
  }
  public ionViewCanEnter() {
    if (
      this.receivedData?.stationType != '' &&
      this.receivedData?.stationType
    ) {
      return true;
    } else {
      return false;
    }
  }
  public getStations() {
    this.dataservice.getStationList$().then((stationData: any) => {
      const stationList = stationData as Station[];
      this.Regd  = this.Regd?.split("-").pop();
        if(this.receivedData.stationType == 'Tripalternate' || this.receivedData.stationType == 'Tripalternate2' || this.receivedData.stationType == 'fromStation'){
            const getStation = this.getParam<string>('stationToFilter', this.stationToFilter);
          if (getStation && this.pageType == 'ScheduleCreation') {
            this.stationList = stationList;
          const departureStation = this.stationList.filter(
            (data) =>
              data.ICAOCode
                .toUpperCase()
                .indexOf(
                  this.getParam<string>('stationToFilter', this.stationToFilter)
                    .split(', ')[0]
                    .toUpperCase()
                ) >= 0
          ) as Station[];
        this.stationList =  this.dataservice?.filterArr(
          this.stationList,
          departureStation[0]
        );
        this.firstStationData=departureStation[0];
        this.fromStationLatLong = departureStation[0].Latitude+"," +departureStation[0].Longitude;
        const minRunwayLength = this.getParam<string>('minimumRunwayLength', this.minimumRunwayLength);
        if (minRunwayLength) {
          this.stationListFilteredWithRunwayLength(
            minRunwayLength,
            this.stationList
          );
        }
          } else {
            this.stationList = stationList;
            const searchDepStation = (getStation || '').split(', ')[0].toUpperCase();
            if (!searchDepStation) {
              this.firstStationData = undefined;
              this.fromStationLatLong = '';
              this.filterListOfSTations = this.stationList;
              this.dataLoaded = true;
              this.autocompleteItems = this.stationList.slice(0, 20);
              return;
            }
            const departureStation = this.stationList.filter(
              (data) => data.ICAOCode
              .toUpperCase()
              .indexOf(searchDepStation) >= 0
             ) as Station[];
             this.firstStationData=departureStation[0]
        this.stationList =  this.dataservice?.filterArr(
          this.stationList,
          departureStation[0]
        );
        this.fromStationLatLong = departureStation[0].Latitude+"," +departureStation[0].Longitude;
        const minRunwayLength = this.getParam<string>('minimumRunwayLength', this.minimumRunwayLength);
        if (minRunwayLength) {
          this.stationListFilteredWithRunwayLength(
            minRunwayLength,
            this.stationList
          );
        }
          }
        }
        else{
          this.Regd == 'TEST'
          ? this.stationFiltered(stationList)
          : (this.stationList = stationList);
        }
        this.filterListOfSTations=this.stationList;
      if (
        this.receivedData.stationType == 'to' ||
        this.receivedData.stationType == 'from'
      ) {
        const getStation = this.getParam<string>('stationToFilter', this.stationToFilter);
        if (getStation && this.pageType == 'ScheduleCreation') {
          const departureStation = this.findStationByCodeOrName(
            this.getParam<string>('stationToFilter', this.stationToFilter),
            this.stationList
          );
          if (departureStation) {
            this.stationList = this.dataservice?.filterArr(
              this.stationList,
              departureStation
            );
            this.firstStationData = departureStation;
            this.fromStationLatLong = `${departureStation.Latitude},${departureStation.Longitude}`;
          }
          const minRunwayLength = this.getParam<string>('minimumRunwayLength', this.minimumRunwayLength);
          if (minRunwayLength) {
            this.stationListFilteredWithRunwayLength(
              minRunwayLength,
              this.stationList
            );
          }
        } else {

        }
      }
      this.ensureFromStationFallback();
      this.dataLoaded = true;
      this.autocompleteItems = this.stationList.slice(0, 20);
      if (this.autocomplete != '' && this.autocomplete != undefined) {
        this.updateSearch();
      }
      setTimeout(() => { }, 600);
    });
  }
  private focusSearchbar(): void {
    const searchbar = this.searchbar as any;
    if (!searchbar) {
      return;
    }
    if (typeof searchbar.setFocus === 'function') {
      searchbar.setFocus();
      return;
    }
    if (searchbar.el && typeof searchbar.el.querySelector === 'function') {
      const inputEl = searchbar.el.querySelector('input') as HTMLInputElement | null;
      inputEl?.focus();
    }
  }

  private getParam<T>(key: string, fallback?: T): T {
    if (fallback !== undefined && fallback !== null) {
      return fallback as T;
    }
    const legacyKeyMap: Record<string, string> = {
      Regd: 'RegdInput',
      pageType: 'pageTypeInput',
      SelectedAltTrip: 'SelectedAltTrip',
      Latitude: 'Latitude',
      Longitude: 'Longitude',
      SetTrip: 'SetTrip',
      minimumRunwayLength: 'minimumRunwayLength',
      stationToFilter: 'stationToFilter',
      speed: 'speed',
      SendData: 'SendData',
    };
    const instanceKey = legacyKeyMap[key] ?? key;
    return (this as any)[instanceKey] as T;
  }

  private findStationByCodeOrName(stationRef: string, stations: Station[]): Station | undefined {
    if (!stationRef || !stations?.length) {
      return undefined;
    }
    const stationKey = stationRef.split(',')[0]?.trim()?.toUpperCase();
    if (!stationKey) {
      return undefined;
    }
    return stations.find((data) =>
      [data?.ICAOCode, data?.IATACode, data?.FAAIdent]
        .filter(Boolean)
        .some((code) => code.toUpperCase() === stationKey)
    );
  }

  private ensureFromStationFallback(): void {
    if (this.firstStationData?.ICAOCode) {
      return;
    }
    const stationRef = this.getParam<string>('stationToFilter', this.stationToFilter)
      || this.setTrip?.fromStation
      || this.getParam<RecivedParams>('SendData', this.SendData)?.departure;
      if (!stationRef) return;
    const fallbackStation = this.findStationByCodeOrName(stationRef, this.stationList);
    if (fallbackStation) {
      this.firstStationData = fallbackStation;
      this.fromStationLatLong = `${fallbackStation.Latitude},${fallbackStation.Longitude}`;
    }
  }
  public stationListFilteredWithRunwayLength(minimumRunwayLength: any, stationData: any) {
    this.stationList = stationData.filter((currentElement: Station) => {
      return (
        (currentElement.maxRunwayLength as number) >=
        parseFloat(minimumRunwayLength)
      );
    });
  }
  /*
  For Test aircraft stations has to be restricted for VOHS, VIDP, OMDB should show.
  */
  public stationFiltered(staionData: any) {
    this.stationList = staionData.filter((currentElement: any) => {
      return (
        currentElement.ICAOCode === 'VOHS' ||
        currentElement.ICAOCode === 'OMDB' ||
        currentElement.ICAOCode === 'VIDP'
      );
    });
  }
  public dismiss() {
    const sendAltData = this.pageType == 'ScheduleCreation' && this.receivedData.stationType == 'Tripalternate' ? this.dataservice.storeAltStn : this.pageType == 'ScheduleCreation' && this.receivedData.stationType == 'Tripalternate2' ? this.dataservice.storeAltStn2 : null
    this.modalController.dismiss(sendAltData);
  }
  public updateSearch(ev?: any) {
    this.autocomplete = ev ? ev.target.value : this.autocomplete;
    if (this.autocomplete != '') {
      if (
        this.receivedData.stationType == 'Tripalternate' ||
        this.receivedData.stationType == 'Tripalternate2' ||
        this.receivedData.stationType == 'Deaprtalternate' ||
        this.receivedData.stationType == 'fromStation'
      ) {
          this.filterListOfSTations = this.SelectStation[0] != this.firstStationData?.ICAOCode ? this.filterListOfSTations.filter((filterData: any) => filterData.ICAOCode !== this.firstStationData.ICAOCode) : this.filterListOfSTations;
          const element1 = this.filterListOfSTations ?  this.filterListOfSTations.filter((data: any) =>
            data.ICAOCode === this.SelectStation[0] ||
          (data.searchIndexString
              ? data.searchIndexString
                .toUpperCase()
                .indexOf(this.autocomplete.toUpperCase()) >= 0
              : data.searchIndexitem
                .toUpperCase()
                .indexOf(this.autocomplete.toUpperCase()) >= 0
        )): [];
        this.autocompleteItems = [];
        this.autocompleteItems = element1.sort((a: any, b: any) => {
      const isASelectStation = a.ICAOCode === this.SelectStation[0];
      const isBSelectStation = b.ICAOCode === this.SelectStation[0];
      if (isASelectStation) return -1;
      if (isBSelectStation) return 1;
      return a.Distance < b.Distance ? -1 : 1;
    }).slice(this.autocompleteItems.length, this.autocompleteItems.length + 20);
        }
      if (
        this.receivedData.stationType == 'from' ||
        this.receivedData.stationType == 'to'
      ) {
        if (this.autocomplete == '' || this.autocomplete == ' ') {
          this.autocompleteItems = this.stationList.slice(0, 50);
        } else {
          if (!this.autocomplete) {
            return false;
          }
          this.sortedStationList = this.stationList
            ? this.stationList.filter(
              (data) =>
              data.ICAOCode === this.SelectStation[0] || [
                  data.ICAOCode,
                  !this.isFirstStationSelected?data.IATACode:'',
                  !this.isFirstStationSelected?data.CityName:'',
                  !this.isFirstStationSelected?data.Country:'',
                  !this.isFirstStationSelected?data.AirportName:'',
                ].find((e) =>
                  e.toUpperCase().includes(this.autocomplete.toUpperCase())
                ) !== undefined
            )
            : [];
          this.autocompleteItems = [];
          this.autocompleteItems = this.sortedStationList
            .sort((stationA: any, stationB: any) => {
              if(stationA.ICAOCode === this.SelectStation[0]) return -1;
              if(stationB.ICAOCode === this.SelectStation[0]) return 1;
              return stationA.ICAOCode < stationB.ICAOCode ? -1 : 1;
            })
            .slice(
              this.autocompleteItems.length,
              this.autocompleteItems.length + 20
            );
        }
      }
    } else {
      if (
        this.receivedData.stationType == 'from' ||
        this.receivedData.stationType == 'to'
      ) {
      this.autocompleteItems = this.stationList.sort((stationA, stationB) => {
        if(stationA.ICAOCode === this.SelectStation[0]) return -1;
        if(stationB.ICAOCode === this.SelectStation[0]) return 1;
        return stationA.ICAOCode < stationB.ICAOCode ? -1 : 1;
      }).slice(0,20);
    } else if(this.receivedData.stationType == 'Tripalternate' ||
      this.receivedData.stationType == 'Tripalternate2' ||
      this.receivedData.stationType == 'Deaprtalternate' ||
      this.receivedData.stationType == 'fromStation') {
        const filterFrmToStation = this.SelectStation[0] != this.firstStationData.ICAOCode ? this.filterListOfSTations.filter((data: any) => data.ICAOCode !== this.firstStationData.ICAOCode) : this.filterListOfSTations;
        this.autocompleteItems = filterFrmToStation.sort((stationA: any, stationB: any) => {
            if(stationA.ICAOCode === this.SelectStation[0]) return -1;
            if(stationB.ICAOCode === this.SelectStation[0]) return 1;
            return stationA.Distance < stationB.Distance ? -1 : 1;
          }).slice(0, 20);
      }
    }
  }
 public onInputChange() {
    this.search();
  }
 public search() {
  if(this.autocompleteItems.length)
  {
    for (let i = 0; i < this.autocompleteItems.length; i++) {
      const paragraphId = `paragraph${i}`;
      const paragraph = document.getElementById(paragraphId) as HTMLParagraphElement;
      if (paragraph) {
        const escapedTextToSearch = this.autocomplete.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const pattern = new RegExp(`${escapedTextToSearch}`, "gi");
        paragraph.innerHTML = paragraph.textContent.replace(pattern, match => `<strong>${match}</strong>`);
      }
    }
  }
  }
  public doinfinite(infiniteScroll: any) {
    const stationListlength = this.autocompleteItems.length;
    const stationsList =
      !this.autocomplete || (this.autocomplete && this.autocomplete == ' ')
        ? this.stationList
        : this.sortedStationList;
    const tempAircraftList = stationsList.slice(
      stationListlength,
      stationListlength + 20
    );
    tempAircraftList.forEach((element) => {
      this.autocompleteItems.push(element);
    });
    infiniteScroll.target.complete();
  }
  public confirm() {
    if (this.fullStation) {
      this.fullStation =
        this.SelectStation.length > 0 ? this.fullStation : undefined;
      this.modalController.dismiss(this.fullStation);
    }
  }
  public async chooseItem(item: Station) {
    this.toStationLatLong=item.Latitude + "," +item.Longitude;
    let selectedStation = '';
    if (item.ICAOCode != '') {
      selectedStation = selectedStation + item.ICAOCode;
    } else if (item.IATACode != '') {
      selectedStation = selectedStation + item.IATACode;
    } else if (item.FAAIdent != ' ') {
      selectedStation = selectedStation + item.FAAIdent;
    }
    this.distance = item.Distance;
     if (!this.distance && this.fromStationLatLong) {
    const [fromLat, fromLng] = this.fromStationLatLong.split(',').map(Number);
    const toLat = Number(item.Latitude);
    const toLng = Number(item.Longitude);
    if (fromLat && fromLng && toLat && toLng) {
      this.distance = this.calculateNM(fromLat, fromLng, toLat, toLng).toFixed(0);
    }
  }
    const index: number = this.SelectStation.indexOf(selectedStation);
    this.autocomplete = item.ICAOCode;
    this.unselectStation(item, selectedStation);
    selectedStation =
      selectedStation +
      ', ' +
      item.AirportName +
      ', ' +
      item.CityName +
      ', ' +
      item.Country;
    if (this.receivedData.stationType == 'to') {
      if(
        (this.SelectStation.indexOf(item.ICAOCode) != -1 ||
        this.SelectStation.indexOf(item.IATACode) != -1 ||
        this.SelectStation.indexOf(item.FAAIdent) != -1)
        )
      {
        this.isFirstStationSelected=true;
      }
      else
      {
        this.isFirstStationSelected=false;
      }
      this.fullStation = new StationDetails(selectedStation, item.timezone,item);
      this.isStationSelected=true;
      this.flightPlanUrl =
        googleMapProperty.mapUrl +
        googleMapProperty.size +
        googleMapProperty.fromStationMarkers +
        this.fromStationLatLong +
        googleMapProperty.toStationMarkers +
        this.toStationLatLong +
        googleMapProperty.mapType +
        googleMapProperty.mapKey +
        this.fromStationLatLong +
        googleMapProperty.verticalPipe +
        this.toStationLatLong;
      this.setTrip.toStation=this.fullStation.name
      this.setTrip.endtimeZone=this.fullStation.timeZone
      if(this.commonService.roleId=='7')
      {
        await this.commonService.showSpinnerLoader();
        try {
          await this.fetchDistanceBetweenStations();
        } finally {
          await this.commonService.dismissLoader();
        }
      }
    } else {
      if (this.receivedData.stationType == 'from') {
        this.fullStation = new StationDetails(selectedStation, item.timezone , item);
        this.firstStationData=this.fullStation;
      } else {
        if(
          (this.SelectStation.indexOf(item.ICAOCode) != -1 ||
          this.SelectStation.indexOf(item.IATACode) != -1 ||
          this.SelectStation.indexOf(item.FAAIdent) != -1)
          )
        {
          this.isFirstStationSelected=true;
        }
        else
        {
          this.isFirstStationSelected=false;
        }
        selectedStation = item.ICAOCode;
        this.fullStation = new StationDetails(selectedStation, item.timezone,item);
        this.receivedData.stationType == 'Tripalternate' ?  this.dataservice.storeAltStn = new StationDetails(selectedStation, item.timezone,item) : this.dataservice.storeAltStn2 = new StationDetails(selectedStation, item.timezone,item);
        this.isStationSelected=true;
        this.flightPlanUrl =
          googleMapProperty.mapUrl +
          googleMapProperty.size +
          googleMapProperty.fromStationMarkers +
          this.fromStationLatLong +
          googleMapProperty.toStationMarkers +
          this.toStationLatLong +
          googleMapProperty.mapType +
          googleMapProperty.mapKey +
          this.fromStationLatLong +
          googleMapProperty.verticalPipe +
          this.toStationLatLong;
      }
    }
    this.updateSearch();
  }

  public fetchDistanceBetweenStations(): Promise<any> {
    return this.charterTripService.GetBlktime(this.setTrip);
  }
  public unselectStation(station: any, prevStation: any) {
    this.enableConfirm = true;
    const currentStation = [];
    if (this.SelectStation.length > 0) {
      if (
        prevStation != station.ICAOCode ||
        this.SelectStation[0] != station.ICAOCode
      ) {
        currentStation.push(station.ICAOCode);
      }
    } else {
      currentStation.push(prevStation);
    }


    this.SelectStation = currentStation;
  }
  public ionViewDidLeave() {
     this.autocompleteItems = [];
     this.fullStation =  undefined;
  }
  public round(val:any) {
    // return val?.toFixed();
     if (val === null || val === undefined || val === '') return '';
  const num = Number(val);
  return isNaN(num) ? '' : Math.round(num);
  }
  public showWeatherNotams(station: Station) {
    this.commonService.showCommonModal(ScheduleWeatherNotamsComponent, { station }, 'weatherNotams');
  }


  public ngOnDestroy() {
    this.toStationLatLong='';
    this.isStationSelected=false;
  }
  public calculateTime(distance: any) {
    const speedValue = this.getParam<number | string>('speed', this.speed);
    const parsedSpeed = Number(speedValue);
    const SESpeed = Number.isFinite(parsedSpeed) && parsedSpeed > 0 ? parsedSpeed : defaultSESpeed;
     const distanceNum = Number(distance);
  if (!distance || isNaN(distanceNum)) return '00:00';
    // Calculate time in hours
    const timeInHours = distance / SESpeed;
    // Convert time to hours and minutes
    const hours = timeInHours != 0 ? Math.floor(timeInHours) : 0o0;
    const minutes = timeInHours != 0 ? Math.round((timeInHours - hours) * 60) : 0o0;
    return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}`;
  }
private calculateNM(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 3440.065; // Earth radius in nautical miles
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) *
    Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

}
